var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"elevation-0 mx-2",staticStyle:{"color":"white"},attrs:{"color":"#CC3300","loading":_vm.loading,"depressed":"","disabled":_vm.disable},on:{"click":_vm.search}},[_c('v-icon',{staticClass:"mr-2",staticStyle:{"color":"white"}},[_vm._v("picture_as_pdf")]),_vm._v(" Gerar PDF ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }